

















import BaseComponent from '@/components/base-component.vue';
import Component from 'vue-class-component';
import { GChart } from 'vue-google-charts/legacy'
import { Prop } from 'vue-property-decorator';

@Component({
  components: {
    GChart,
  },
})
export default class ProductLineChart extends BaseComponent {
  @Prop({ default: 'Título' })
  private titulo: string;

  private show: boolean = false;

  @Prop()
  private chartData: any[];

  @Prop()
  private vAxisTitle: string;

  @Prop({ default: 0 })
  private vAxisMinValue: number;

  @Prop({ default: '500px' })
  private minWidth: string;

  mounted() {
    setTimeout(() => {
      this.show = true;
    }, 100);
  }

  private chartOptions = {
    //curveType: 'function',
    backgroundColor: 'transparent',
    /*width: 500,
    height: 300,*/
    chartArea: { left: '10%', top: '10%', width: '85%', height: '60%' },
    legend: { position: 'none' },
    hAxis: {
      slantedText: true,
    },
    vAxis: {
      title: null,
      minValue: 0,
    },
  };

  private getChartOptions() {
    this.chartOptions.vAxis.title = this.vAxisTitle;
    this.chartOptions.vAxis.minValue = this.vAxisMinValue;
    return this.chartOptions;
  }
}
